import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import css from "../../css/listing/header.module.css";
import { format, parseISO } from "date-fns";
import isRent from "../../helper/isRent";
import moneyFormatter from "../../helper/moneyFormatter";
import { LISTING_SOURCE_STATUSES } from "../../service/listing";

const Header = (props) => {
    const { listing } = props;

    const [listedDate, setListedDate] = useState(null);

    useEffect(() => {
        setListedDate(format(parseISO(listing.listed_date), "MMM do, yyyy"));
    }, [listing.listed_date]);

    const status = listing.source_status.name.toLowerCase();
    const rent = isRent(listing);
    const category = rent ? "For Rent" : "For Sale";
    let price = null;

    if (listing.price && listing.price > 0) {
        price = rent
            ? `${moneyFormatter(0).format(listing.price)}/mo`
            : moneyFormatter(0).format(listing.price);
    }

    return (
        <div className={css.header}>
            <div className={css.wrapper}>
                <div className={css.address}>
                    <h1>
                        {listing.address} {listing.unit_number || ""}
                        <span>
                            {listing.city.name}, {listing.state.abbr}{" "}
                            {listing.zip.code}
                        </span>
                    </h1>
                </div>
                <div className={css.params}>
                    {price && (
                        <div className={css.param}>
                            <div className={css.paramTitle}>Price</div>
                            <div className={css.paramValue}>{price}</div>
                        </div>
                    )}
                    <div className={css.param}>
                        <div className={css.paramTitle}>Listed On</div>
                        <div className={css.paramValue}>{listedDate}</div>
                    </div>
                    <div className={css.param}>
                        <div className={css.paramTitle}>Type</div>
                        <div className={css.paramValue}>{category}</div>
                    </div>
                    <div className={css.param}>
                        <div className={css.paramTitle}>Status</div>
                        <div className={css.paramValue}>
                            <span className={css[`badge-${status}`]}>
                                {LISTING_SOURCE_STATUSES[status]}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Header.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default Header;
